(function($) {
  'use strict';

  var $html = $('html');
  var $window = $(window);

  /* "More" nav ---------------- */
  // This could be pluginized
  var $wrapper = $('[data-type="more-wrapper"]');
  var $primary = $($wrapper.data('more-primary'));
  var $secondary = $($wrapper.data('more-secondary'));
  var $toggle = $($wrapper.data('more-toggle'));
  var $toggleWrapper = $($wrapper.data('more-toggle-wrapper'));
  var persist = $toggle.is('[data-more-persist]');
  var moreShowingClass = 'more_nav_showing';
  var childOrder = [];

  // Preserve the order of the children
  $primary.children().each(function() {
    childOrder.push(this);
  });

  var getChildrenWidth = function() {
    var $children = $primary.children();

    var childrenWidth = 0;
    $children.each(function() {
      var $this = $(this);
      // Note, may need to fix this in case of margins
      var width = $this.width();

      $this.data('__last-width', width); // Is this worth caching?
      childrenWidth += width;
    });

    return childrenWidth;
  };

  var check = function() {
    $wrapper.css({
      overflow: 'hidden',
      flexGrow: 1
    });

    if (persist) {
      $html.addClass(moreShowingClass);
      $toggleWrapper.show();
    }

    for (var i = 0, l = childOrder.length; i < l; i++) {
      $primary.append(childOrder[i]);
    }

    var $children = $primary.children();
    var childrenWidth = getChildrenWidth();
    var wrapperWidth = $wrapper.width();

    if (childrenWidth > wrapperWidth) {
      $html.addClass(moreShowingClass);
      $toggleWrapper.show();
      $children = $children.filter(':not([data-more-keep])');

      var removedWidth = 0;
      for (i = $children.length - 1; i >= 0; i--) {
        var $child = $children.eq(i);
        if (!$child.is(':visible')) {
          continue;
        }

        var width = $child.data('__last-width');
        $secondary.append($child);
        removedWidth += width;

        if (childrenWidth - removedWidth <= wrapperWidth) {
          break;
        }
      }
    } else if (!persist) {
      $toggleWrapper.hide();
      $html.removeClass(moreShowingClass);
    }

    $wrapper.css({
      overflow: '',
      flexGrow: ''
    });
  };

  var delayCheckTO;

  // check if the zds header class is present on the page
  if (!$('.site_header_zds')[0]) {
    $window.on('resize', function() {
      clearTimeout(delayCheckTO);
      delayCheckTO = setTimeout(check, 100);
    });

    $(window).on('load', (function() {
      check();
      $wrapper.addClass('nav_checked');

      // We're going to assume this is the only nav on the page for now
      // and just add a global class to say it's shown
      $html.addClass('nav_checked');
    }));
  }

  /* Nav toggle ---------------- */

  var openClass = 'force_open';

  // Open subnav and focus
  var openAndFocusSubNav = function($nav) {
    closeSubNavs();
    $nav.addClass(openClass);

    if (!$nav.is('.force_open_nav')) {
      var $subnav = $nav.find('.sub_nav').eq(0);
      $subnav.attr('tabIndex', -1).focus();
    }
  };

  // Close all navs
  var closeSubNavs = function() {
    $('.site_header .item').removeClass(openClass);
    $('.site_header_zds .item').removeClass(openClass);
  };

  // Open or close nav and focus
  var toggleAndFocusSubNav = function() {
    var $nav = $(this).closest('.item');

    if ($nav.hasClass(openClass)) {
      closeSubNavs();
    } else {
      openAndFocusSubNav($nav);
    }
  };

  // Open nav, do not focus
  var openSubNav = function() {
    closeSubNavs();
    $(this).closest('.item').addClass(openClass);
  };

  var mousing = false; // Don't trigger keyboard stuff while clicking
  $(document)
    // Stop focusout code from firing
    .on('mousedown', '.item > button', function() {
      mousing = true;
      setTimeout(function() {
        mousing = false;
      }, 0);
    })
    // toggle on nav click
    .on('click', '.item > button', function(e) {
      toggleAndFocusSubNav.call(this, e);
    })
    // close on not-nav click
    .on('click', function(e) {
      if (!$(e.target).is('.site_header [data-type="navs"] *') && !$(e.target).is('.site_header_zds [data-type="navs"] *')) {
        closeSubNavs();
      }
    })
    // open when tabbed into
    .on('focusin', '.sub_nav', function(e) {
      openSubNav.call(this, e);
    })
    // close when tabbed out of
    .on('focusout', '.sub_nav', function() {
      if (!mousing) {
        closeSubNavs();
      }
    });
}(window.jQuery || window.$));
